import { render } from "./Hospitals.vue?vue&type=template&id=5be83be8"
import script from "./Hospitals.vue?vue&type=script&lang=js"
export * from "./Hospitals.vue?vue&type=script&lang=js"
script.render = render

export default script